import React, { useEffect, useState } from "react";
import Base from "../Base";
import FileUpload from "../common/FileUpload";
import instance from "../../services/baseService";
import { Collapse } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { HiDownload } from "react-icons/hi";
import { FaCheck, FaCircleDot, FaCircleUser } from "react-icons/fa6";
import toast from "react-hot-toast";
import { GoCommentDiscussion } from "react-icons/go";
import RefundForm from "./RefundForm";
import RefundList from "./RefundList";
import { useDispatch, useSelector } from "react-redux";
import { useParams, NavLink } from "react-router-dom";
import moment from "moment";
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import {
  Badge,
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
  Breadcrumb,

} from "react-bootstrap";
import ChatPopup from "../common/ChatPopup";
import ViewSheetSummary from "../ViewSheetSummary";
import { CRUD_PERMISSIONS } from "../../constants/user";
import useCheckAuthorization from "../../hooks/checkAuthorization";
import {
  addPeriod,
  resetStore,
} from "../../slices/periodReducer";
import StepProgressBar from "../common/StepProgressBar";
import { clearNotification } from '../../slices/notificationReducer';
import { CURRENT_MONTH_ENABLE_DAY, extractErrorMessage } from "../../constants/common";
import { getFileIconClass } from '../../utils/fileExtension';
import ImportDrawer from "../common/importBills/ImportDrawer";
import FolderListModal from "../common/importBills/FolderListModal";
import DownloadButton from "../common/DownloadButton";
import { truncateText, truncateTextOnly } from "../../utils";
import DynamicModal from "../Employees/DynamicModal";
import useSidebar from "../../hooks/useSidebar";

const Refunds = () => {
  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;
  const [activeTab, setActiveTab] = useState(0);
  const [activeSubTab, setActiveSubTab] = useState(0);
  const [rightTab, setRightTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [summaryFile, setSummaryFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadingBill, setUploadingBill] = useState(false);
  //const [sheetData, setSheetData] = useState(null);
  const [summaryData, setSummaryData] = useState([]);
  const [sheetSummaryData, setSheetSummaryData] = useState(null);
  const [currentAction, setCurrentAction] = useState({});
  //const [reloadSheet, setReloadSheet] = useState(false);
  const { isNotificationRoute, notification } = useSelector((state) => state.notification);
  const { collapse, expand, isSidebarCollapsed } = useSidebar();

  const [allComments, setAllComments] = useState([]);
  const [file, setFile] = useState(null);
  const [billsData, setBillsData] = useState([]);
  const [refundData, setRefundData] = useState([]);
  const [existingRefundItem, setExistingRefundItem] = useState({});
  const [refundStatusOptions, setRefundStatusOptions] = useState([]);
  const [periodData, setPeriodData] = useState([]);
  const [periodId, setPeriodId] = useState("");
  const [approverLevels, setApproverLevels] = useState({});
  const { client_id } = useParams();
  const manageAllClientsPermission = useCheckAuthorization(CRUD_PERMISSIONS.sheet.manage_clients);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    message: "",
    onConfirm: null
  });
  const {
    loading: periodUpdateLoading,
    error: periodError,
    success: periodSuccess,
    successMsg
  } = useSelector((state) => state.periods)
  const today = dayjs();
  const [current_page, setCurrentPage] = useState(1);
  const currentMonthStart = today.startOf('month');
  const currentMonthEnd = today.endOf('month');
  const initialMonthRange = today.date() >= CURRENT_MONTH_ENABLE_DAY
    ? [currentMonthStart, currentMonthEnd]
    : [currentMonthStart.subtract(1, 'month'), currentMonthEnd.subtract(1, 'month')];
  const [importedData, setImportedData] = useState(null);
  const [folderListModalOpen, setFolderListModalOpen] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState(initialMonthRange);
  const [periodName, setPeriodName] = useState("");
  const [periodErrors, setPeriodErrors] = useState({
    periodName: "",
    monthRange: "",
    errorResponse: ""
  });

  const tabs = ["Shipping Bill", "Sales Register", "Invoices", "Others"];
  const section_type = {
    1: "Shipping Bill",
    2: "Sales Register",
    3: "Invoices",
    4: "Others"
  };
  const handleImportResponse = (data) => {
    setImportedData(data);
    collapse();
    setFolderListModalOpen(true)
  };
  const getSheet = async (period_id) => {
    try {
      setLoading(true);
      //setSheetData(null);
      const res = await instance.post(
        `/api/v1/client/refund/view/sheet/${client_id}`,
        {
          folder_id: period_id
        }
      );
      if (res.data?.data)
        setSheetSummaryData(res.data?.data);
      setApproverLevels(res.data?.data?.approver_levels);
      setCurrentAction(res.data?.data?.current_action)
      if (res.data?.data?.sheet !== null) {
        // setSheetData(res.data?.data?.sheet);
        //setReloadSheet(true);
      }
      setAllComments(res.data?.data?.all_comments);
      setSummaryData(res.data?.data?.summery);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getPeriodData = async () => {
    try {
      const res = await instance.get(`/api/v1/statement/folder/list/${client_id}/1/10/1`);
      setPeriodData(res.data.data.list);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    }
  }

  const handlePeriodSelect = async (period_id) => {
    setPeriodId(period_id);
    if (period_id) {
      await getSheet(period_id);
    } else {
      //setSheetData(null);
      setSheetSummaryData(null);
    }
  }


  const NotePreview = ({ note }) => {
    const [expanded, setExpanded] = useState(false);
    const limit = 50; // Character limit before truncation

    const toggleExpanded = () => setExpanded(!expanded);

    const isLong = note.length > limit;
    const visibleText = expanded ? note : note.slice(0, limit);

    return (
      <div className="bg-green-100 text-green-900 p-3 rounded break-words whitespace-pre-wrap text-sm">
        {visibleText}
        {isLong && (
          <span
            onClick={toggleExpanded}
            className="text-blue-600 cursor-pointer font-semibold ml-2"
          >
            {expanded ? "less" : "...more"}
          </span>
        )}
      </div>
    );
  };




  const submit = async () => {
    if (!periodId) {
      toast('Please Select a valid Period');
    }
    setUploadingBill(true);
    //setReloadSheet(false);
    try {
      setLoading(true);
      const promise = instance.post(
        `/api/v1/client/refund/sheet/upload/${client_id}`,
        {
          folder_id: periodId,
          file: file,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const response = await toast.promise(promise, {
        loading: "Uploading...",
        success: <b>Uploaded!</b>,
        error: <b>Uploading Failed.</b>,
      });
      console.log('response', response);
      if (response.data.type === 'success')
        getSheet(periodId);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setFile(null);
      setUploadingBill(false);
    }
  };

  // const downloadBillsZip = async (item) => {
  //   try {
  //     const promise = instance.post(
  //       `/api/v1/client/refund/download/zip/${client_id}`,
  //       {
  //         note_id: item.id,
  //       },
  //       {
  //         responseType: 'blob',   // Important! Tells axios to handle the response as a blob
  //       }
  //     );
  //     const response = await toast.promise(promise, {
  //       loading: "Downloading...",
  //       success: <b>Downloaded!</b>,
  //       error: <b>Downloading Failed.</b>,
  //     });
  //     // Create a URL for the blob
  //     const url = window.URL.createObjectURL(new Blob([response.data]));

  //     // Create a link element
  //     const link = document.createElement('a');
  //     link.href = url;
  //     const fileName = item.notes.replace(/ /g, "_");
  //     link.setAttribute('download', `${fileName}.zip`); // Specify the filename

  //     // Append to the document and click the link to trigger download
  //     document.body.appendChild(link);
  //     link.click();

  //     // Cleanup
  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //   } catch (error) {
  //     const errorMessage = extractErrorMessage(error);
  //     toast.error(errorMessage);
  //   } finally {
  //   }
  // }x

  // const downloadBillsZip = async (item) => {
  //   try {
  //     const files = item.refund_note_files;

  //     if (!files || files.length === 0) {
  //       toast.error("No files to download");
  //       return;
  //     }

  //     // Show initial toast
  //     const mainToastId = toast.loading(`Starting download of ${files.length} files...`, {
  //       duration: Infinity
  //     });

  //     let completedDownloads = 0;
  //     const totalFiles = files.length;
  //     let currentFileName = '';

  //     // Function to update main progress
  //     const updateMainProgress = (fileName = '', isDownloading = false) => {
  //       const progress = Math.round((completedDownloads / totalFiles) * 100);
  //       const status = isDownloading ? `Downloading: ${fileName}` : `Downloaded ${completedDownloads}/${totalFiles} files`;

  //       toast.loading(
  //         <div>
  //           <div>{status}</div>
  //           <div style={{
  //             width: '200px',
  //             height: '6px',
  //             backgroundColor: '#e5e7eb',
  //             borderRadius: '3px',
  //             marginTop: '8px',
  //             overflow: 'hidden'
  //           }}>
  //             <div style={{
  //               width: `${progress}%`,
  //               height: '100%',
  //               backgroundColor: '#10b981',
  //               transition: 'width 0.3s ease'
  //             }}></div>
  //           </div>
  //           <div style={{ fontSize: '12px', marginTop: '4px' }}>{progress}% complete</div>
  //         </div>,
  //         { id: mainToastId, duration: Infinity }
  //       );
  //     };

  //     // Download each file individually
  //     for (let i = 0; i < files.length; i++) {
  //       const file = files[i];

  //       try {
  //         // Update progress to show current downloading file
  //         updateMainProgress(file.file_name, true);

  //         // Create XMLHttpRequest for download
  //         const downloadPromise = new Promise((resolve, reject) => {
  //           const xhr = new XMLHttpRequest();

  //           xhr.open('GET', file.url, true);
  //           xhr.responseType = 'blob';

  //           xhr.onload = () => {
  //             if (xhr.status === 200) {
  //               resolve(xhr.response);
  //             } else {
  //               reject(new Error(`Failed to download ${file.file_name}`));
  //             }
  //           };

  //           xhr.onerror = () => {
  //             reject(new Error(`Network error downloading ${file.file_name}`));
  //           };

  //           xhr.send();
  //         });

  //         // Wait for download to complete
  //         const blob = await downloadPromise;

  //         // Create download link and trigger download
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', file.file_name);

  //         // Trigger download
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);

  //         // Cleanup blob URL
  //         window.URL.revokeObjectURL(url);

  //         completedDownloads++;
  //         updateMainProgress();

  //         // Small delay between downloads to prevent overwhelming the browser
  //         if (i < files.length - 1) {
  //           await new Promise(resolve => setTimeout(resolve, 500));
  //         }

  //       } catch (fileError) {
  //         console.error(`Error downloading ${file.file_name}:`, fileError);

  //         // Still count as processed for progress
  //         completedDownloads++;
  //         updateMainProgress();
  //       }
  //     }

  //     // Final success message
  //     toast.success(
  //       <div>
  //         <div><b>All downloads completed!</b></div>
  //         <div style={{ fontSize: '12px', marginTop: '2px' }}>
  //           {completedDownloads} files downloaded successfully
  //         </div>
  //       </div>,
  //       { id: mainToastId, duration: 4000 }
  //     );

  //   } catch (error) {
  //     console.error("Error in download process:", error);
  //     toast.error("Download process failed");
  //   }
  // };

  const downloadBillsZip = async (item) => {
    try {
      // Check the flag to determine which logic to use
      if (item.push_to_preface === 0) {
        // Original ZIP download logic
        const promise = instance.post(
          `/api/v1/client/refund/download/zip/${client_id}`,
          {
            note_id: item.id,
          }, {
          responseType: 'blob', // Important! Tells axios to handle the response as a blob
        }
        );

        const response = await toast.promise(promise, {
          loading: "Downloading...",
          success: <b>Downloaded!</b>,
          error: <b>Downloading Failed.</b>,
        });

        // Create a URL for the blob
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        const fileName = item.notes.replace(/ /g, "_");
        link.setAttribute('download', `${fileName}.zip`); // Specify the filename

        // Append to the document and click the link to trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

      } else if (item.push_to_preface === 1) {
        // Individual file download logic with progress and folder selection
        const files = item.refund_note_files;

        if (!files || files.length === 0) {
          toast.error("No files to download");
          return;
        }

        // Show folder picker first
        let directoryHandle = null;
        if (window.showDirectoryPicker) {
          try {
            directoryHandle = await window.showDirectoryPicker();
          } catch (error) {
            if (error.name === 'AbortError') {
              return; // User cancelled
            }
          }
        }

        // Show initial toast
        const mainToastId = toast.loading(`Starting download of ${files.length} files...`, {
          duration: Infinity
        });

        let completedDownloads = 0;
        const totalFiles = files.length;

        // Function to update main progress
        const updateMainProgress = (fileName = '', isDownloading = false) => {
          const progress = Math.round((completedDownloads / totalFiles) * 100);
          const status = isDownloading ? `Downloading: ${fileName}` : `Downloaded ${completedDownloads}/${totalFiles} files`;

          toast.loading(
            <div>
              <div>{status}</div>
              <div style={{
                width: '200px',
                height: '6px',
                backgroundColor: '#e5e7eb',
                borderRadius: '3px',
                marginTop: '8px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${progress}%`,
                  height: '100%',
                  backgroundColor: '#10b981',
                  transition: 'width 0.3s ease'
                }}></div>
              </div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>{progress}% complete</div>
            </div>,
            { id: mainToastId, duration: Infinity }
          );
        };

        // Download each file individually
        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          try {
            updateMainProgress(file.file_name, true);

            if (directoryHandle) {
              // Save to selected folder using File System Access API
              const response = await fetch(file.url);
              const blob = await response.blob();

              const fileHandle = await directoryHandle.getFileHandle(file.file_name, { create: true });
              const writable = await fileHandle.createWritable();
              await writable.write(blob);
              await writable.close();
            } else {
              // Fallback to default browser download method
              const downloadPromise = new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', file.url, true);
                xhr.responseType = 'blob';

                xhr.onload = () => {
                  if (xhr.status === 200) {
                    resolve(xhr.response);
                  } else {
                    reject(new Error(`Failed to download ${file.file_name}`));
                  }
                };

                xhr.onerror = () => {
                  reject(new Error(`Network error downloading ${file.file_name}`));
                };

                xhr.send();
              });

              const blob = await downloadPromise;
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', file.file_name);

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }

            completedDownloads++;
            updateMainProgress();

            // Small delay between downloads to prevent overwhelming the browser
            if (i < files.length - 1) {
              await new Promise(resolve => setTimeout(resolve, 500));
            }

          } catch (fileError) {
            console.error(`Error downloading ${file.file_name}:`, fileError);

            // Still count as processed for progress
            completedDownloads++;
            updateMainProgress();
          }
        }

        // Final success message
        toast.success(
          <div>
            <div><b>All downloads completed!</b></div>
            <div style={{ fontSize: '12px', marginTop: '2px' }}>
              {completedDownloads} files downloaded successfully
            </div>
          </div>,
          { id: mainToastId, duration: 4000 }
        );
      } else {
        // Handle unexpected flag values
        toast.error("Invalid download configuration");
        console.error("Invalid push_to_preface flag value:", item.push_to_preface);
      }

    } catch (error) {
      console.error("Error in download process:", error);
      toast.error("Download process failed");
    }
  };

  const getAllGstFiles = async () => {
    try {
      setLoading(true);
      const res = await instance.post(
        `/api/v1/client/refund/list/files/${client_id}`,
        {
          folder_id: periodId,
          section_type: activeSubTab + 1,
        }
      );
      console.log(res);
      const data = res.data.data.list.map((item) => ({
        key: item?.id,
        label: (
          <p className="font-semibold text-base flex items-start gap-x-2">
            {" "}
            <span className="bg-[#0f4372] text-white rounded-full p-px px-2">
              {item.refund_note_files?.length}
            </span>
            <div className="flex flex-col">
              {truncateTextOnly(item.notes ? item.notes : "Summary", 25)}
              <span className="text-xs font-normal">{moment(item?.updated_date).format('DD-MM-YYYY')}</span>
            </div>
          </p>
        ),
        section: item?.section,
        children: (
          <div>
            <div class="pfa-down-all"><a class="badge badge-success1" href="#" onClick={() => downloadBillsZip(item)} >Download all <i class="las la-download"></i></a></div>
            <ul className="divide-y">
              {item?.refund_note_files.map((file, i) => (
                <li
                  key={i}
                  className="flex justify-between uppercase py-3 text-[#0f4372]"
                >
                  {file?.file_name}{" "}
                  <DownloadButton file={file} client_id={client_id} section="REFUND" />
                </li>
              ))}
            </ul>
            {/* {item.notes && (
              <p className="pa-acc-notes alert alert-success">{truncateText(item.notes ? item.notes : "Summary", 25)}</p>
            )} */}
            {item.notes && (
              <p className="pa-acc-notes alert alert-success">
                <NotePreview note={item.notes} />
              </p>
            )}

          </div>
        ),
      }));
      setBillsData(data);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const getRefundData = async () => {
    try {
      setLoading(true);
      const res = await instance.post(
        `/api/v1/client/refund/list/arn/${client_id}`,
        {
          folder_id: periodId,
          page: 1,
          perpage: 5,
          arn_date: moment(),
        }
      );

      setRefundData(res.data.data.list);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleRefundSubmit = async (
    { arnDate, arnNo, arnStatus },
    refundId
  ) => {
    try {
      setLoading(true);
      let promise;
      if (refundId) {
        promise = instance.post(
          `api/v1/client/refund/update/arn/${client_id}/${refundId}`,
          {
            folder_id: periodId,
            arn_no: arnNo,
            arn_date: arnDate,
            status: arnStatus,
          }
        );
      } else {
        promise = instance.post(`api/v1/client/refund/add/arn/${client_id}`, {
          folder_id: periodId,
          arn_no: arnNo,
          arn_date: arnDate,
          status: arnStatus,
        });
      }

      await toast.promise(promise, {
        loading: "Saving...",
        success: <b>Refund Saved Successfully!</b>,
        error: <b>Adding Refund Failed.</b>,
      });
      await getRefundData();
      setExistingRefundItem({});
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
    //dispatch(createUser({ name, email, role, password, phone }));
  };

  const triggerDelete = (refundId) => {
    setConfirmModal({
      show: true,
      message: `Are you sure you want to delete this?`,
      onConfirm: () => handleRefundDelete(refundId)
    });
  };

  const handleRefundDelete = async (refundId) => {
    try {
      setLoading(true);
      const promise = instance.post(
        `api/v1/client/refund/delete/arn/${client_id}/${refundId}`,
        {
          folder_id: periodId
        }
      );

      await toast.promise(promise, {
        loading: "Deleting...",
        success: <b>Refund Deleted Successfully!</b>,
        error: <b>Deleting Refund Failed.</b>,
      });
      await getRefundData();
      // Perform delete action
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSummaryFileChange = (files) => {
    const selectedFiles = Array.from(files); // Convert FileList to array
    setSummaryFile(selectedFiles);
    uploadSummaryFiles(selectedFiles);
  };

  const uploadSummaryFiles = async (files) => {
    setUploading(true);
    const formData = new FormData();
    files.forEach((fileSingle) => {
      formData.append("files", fileSingle);
    });
    formData.append("folder_id", periodId);
    try {
      const promise = instance.post(
        `/api/v1/client/refund/upload/arsheet/${client_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await toast.promise(promise, {
        loading: "Uploading...",
        success: <b>Uploaded!</b>,
        error: <b>Uploading Failed.</b>,
      });
      getSheet(periodId);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setSummaryFile(null);
      setUploading(false);
    }
  };

  const handleSummaryApprove = async (id, status) => {
    setLoading(true);
    try {
      const promise = instance.post(
        `/api/v1/client/refund/summery/approve/${client_id}/${id}`,
        {
          folder_id: periodId,
          approve: status,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await toast.promise(promise, {
        loading: "Submitting...",
        success: (response) => <b>{response.data.message || "Summary Submitted Successfully!"}</b>,
        error: (error) => <b>{error.response?.data?.message || "Submission Failed."}</b>,
      });
      getSheet();

    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }

  const hadleDeleteSheet = async (sheetId) => {
    try {
      setLoading(true);
      const promise = instance.post(`/api/v1/client/refund/delete/sheet/${client_id}`, {
        sheet_id: sheetId,
      });
      await toast.promise(promise, {
        loading: "Deleting...",
        success: <b>Deleted!</b>,
        error: <b>Deleting Failed.</b>,
      });
      getSheet(periodId);


    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }

  const handleRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      setSelectedMonths(dates);
    } else {
      setSelectedMonths([
        currentMonthStart,
        currentMonthEnd,
      ]);
    }
  };

  const handleRefundPeriodSubmit = async (e) => {
    e.preventDefault();
    setPeriodErrors({ periodName: "", monthRange: "", errorResponse: "" });
    if (selectedMonths.length > 0 && periodName.trim() !== '') {
      const firstMonthFirstDate = selectedMonths[0].startOf('month').format('YYYY-MM-DD');
      const lastMonthLastDate = selectedMonths[1].endOf('month').format('YYYY-MM-DD');
      setLoading(true);
      dispatch(addPeriod({ is_prefix: 1, client_id, current_page, start_date: firstMonthFirstDate, end_date: lastMonthLastDate, folder_name: periodName }));

    } else {
      if (selectedMonths.length === 0) {
        setPeriodErrors(() => {
          return {
            ...periodErrors,
            monthRange: 'Please select a month range',
          };
        });
      }
      if (!periodName || periodName.trim() === '') {
        setPeriodErrors(() => {
          return {
            ...periodErrors,
            periodName: 'Please Enter a valid Period Name',
          };
        });
      }
      console.log("Please select both start and end year-month.");
    }
  };

  const disableDate = (current) => {
    const disabledMonths = [
      dayjs("2024-01"),
      dayjs("2024-03"),
      dayjs("2022-01"),
    ];
    if (current && current.isAfter(today, 'month')) {
      return true;
    }

    if (current && current.isSame(today, 'month') && today.date() < CURRENT_MONTH_ENABLE_DAY) {
      return true;
    }
    //return disabledMonths.some(disabledMonth => current.isSame(disabledMonth, 'month'));
  };

  useEffect(() => {
    if (!periodUpdateLoading) {
      setLoading(false);
      getPeriodData();
      if (periodSuccess)
        toast.success(successMsg);
      if (periodError)
        toast.error(periodError);
      setPeriodName("");
      dispatch(resetStore());
    }
  }, [periodUpdateLoading])
  useEffect(() => {
    if (file) {
      submit();
      //console.log("file", file);
    }
  }, [file]);

  useEffect(() => {
    if (periodId)
      getAllGstFiles();
  }, [periodId, activeSubTab]);

  useEffect(() => {
    const getRefundStatuses = async () => {
      try {
        setLoading(true);
        const res = await instance.get(
          `/api/v1/client/refund/status/list/${client_id}`
        );
        //console.log('status', res);
        setRefundStatusOptions(res.data.data.lists);
      } catch (error) {
        const errorMessage = extractErrorMessage(error);
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    };
    if (activeTab === 0) getPeriodData();
    if (activeTab === 0 && periodId) getSheet(periodId);
    if (activeTab === 1 && periodId) getAllGstFiles();
    if (activeTab === 2 && periodId) {
      getRefundStatuses();
      getRefundData();
    }
  }, [activeTab, periodId]);

  const refundEditAction = ({ id, arn_no, arn_date, status }) => {
    const refundItem = {
      id: id,
      arnNo: arn_no,
      arnDate: arn_date,
      arnStatus: status,
    };
    setExistingRefundItem(refundItem);
  };

  const sheetSubmitAction = async (sheetId, status, roleId) => {
    setLoading(true);
    try {
      const requestBody = {
        folder_id: periodId,
        approve: status,
      };
      if (roleId) {
        requestBody.next_level = roleId;
      }
      const promise = instance.post(
        `/api/v1/client/refund/approve/${client_id}`,
        requestBody,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await toast.promise(promise, {
        loading: "Submitting...",
        success: <b>Submitted Successfully!</b>,
        error: <b>Submission Failed.</b>,
      });
      getSheet(periodId);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSheetSubmitManager = async (sheetId, status) => {
    setLoading(true);
    try {
      const promise = instance.post(
        `/api/v1/client/refund/manager/approve/${client_id}/${sheetId}`,
        {
          folder_id: periodId,
          approve: status,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await toast.promise(promise, {
        loading: "Submitting...",
        success: <b>Submitted Successfully!</b>,
        error: <b>Submission Failed.</b>,
      });
      getSheet(periodId);
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSkipSubmit = async (roleId) => {
    sheetSubmitAction(null, null, roleId);
  };

  useEffect(() => {
    if (isNotificationRoute) {
      handlePeriodSelect(notification?.params?.period);
      dispatch(clearNotification());
      getSheet();
    }
  }, [isNotificationRoute]);

  const customExpandIcon = ({ isActive }) => {
    return isActive ? <MinusOutlined size={36} /> : <PlusOutlined size={36} />;
  };

  return (
    <Base header_title="Refunds" hideDatepicker={true}>
      <div className="bg-white shadow-sm rounded-2xl w-full h-full px-3  space-x-3">
        <Row className="mb-3">
          <Col className="mr-auto text-center">
            <Breadcrumb>
              <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
                Dashboard
              </Breadcrumb.Item>
              <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/clients" }}>
                Clients
              </Breadcrumb.Item>
              <Breadcrumb.Item
                linkAs={NavLink}
                linkProps={{ to: `/clients/tax-forms/${client_id}` }}
              >
                Tax-Forms
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Refunds</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row className="pb-10">
          {/* First Column */}
          <Col md={2}>
            <Form.Group controlId="periodSelection">
              <Form.Label>Select Period</Form.Label>
              <Form.Control
                as="select"
                value={periodId}
                onChange={(e) => handlePeriodSelect(e.target.value)}
              >
                <option value="">Select a period</option>
                {periodData.map(periodItem =>
                  <option value={periodItem.id} key={periodItem.id}>{`${periodItem.prefix ? periodItem.prefix + ' - ' : ''}${periodItem.folder_name?.length > 100 ? periodItem.folder_name.slice(0, 100) + '...' : periodItem.folder_name}`}
                  </option>
                )}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={1} className="d-flex align-items-center justify-content-center">
            <strong>OR</strong>
          </Col>
          {/* Second Column with four fields */}
          <Col md={9}>
            <Row>
              <Col md={4}>
                <Form.Group controlId="startYearMonth" hasValidation>
                  <Form.Label>Select Period Range</Form.Label>

                  <div className="hide-clear-icon">
                    <RangePicker
                      picker="month"
                      size="large"
                      format="YYYY-MM"
                      onChange={handleRangeChange}
                      value={selectedMonths}
                      disabledDate={disableDate}
                      style={{ height: '37px' }}
                    />
                  </div>

                  {periodErrors.monthRange && (
                    <div className="invalid-feedback">{periodErrors.monthRange}</div>
                  )}
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group controlId="periodName" hasValidation>
                  <Form.Label>Enter Period Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter period name"
                    value={periodName}
                    onChange={(e) => setPeriodName(e.target.value)}
                    maxLength={100}
                    className={periodErrors.periodName ? 'is-invalid' : ''}
                  />
                  <Form.Control.Feedback type="invalid" className="absolute">{periodErrors.periodName}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={3} className="d-flex align-items-end">
                <Button variant="primary" className="fw-bold" onClick={handleRefundPeriodSubmit} disabled={!periodName.trim()}>
                  Submit
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Period selection */}
        <hr />
        {!periodId ? <div className="d-flex justify-content-center align-items-center" style={{ height: '50px' }}> <h4 className="text-center p-1 ">Please Select a Period</h4></div> : <>
          <div className="mb-3">
            <span
              onClick={() => setActiveTab(0)}
              className={`${activeTab === 0 ? "bg-[#F37920] text-white" : ""
                } cursor-pointer p-2 px-3 rounded-full relative`}
            >
              View Form
              {activeTab === 0 && (
                <div className=" absolute w-0 h-0 left-10 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
              )}
            </span>
            <span
              onClick={() => setActiveTab(1)}
              className={`${activeTab === 1 ? "bg-[#F37920] text-white" : ""
                } cursor-pointer p-2 px-3 rounded-full relative`}
            >
              Download Bills
              {activeTab === 1 && (
                <div className=" absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
              )}
            </span>
            <span
              onClick={() => setActiveTab(2)}
              className={`${activeTab === 2 ? "bg-[#F37920] text-white" : ""
                } cursor-pointer p-2 px-3 rounded-full relative`}
            >
              Refund status
              {activeTab === 2 && (
                <div className=" absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
              )}
            </span>
          </div>
          {activeTab === 0 && (
            <div>
              <div>
                {sheetSummaryData && <StepProgressBar approverLevels={approverLevels} />}
                <h1 className="text-xl flex gap-x-2 items-center">
                  <img
                    className="w-10"
                    src="../assets/icons/up-loading.png"
                    alt="Upload Icon"
                  />
                  Upload summary for client approval
                </h1>
                <div className="mb-1">Upload Refunds form here (Single sheet excel file only allowed)</div>
                {uploadingBill ? (
                  <div className="text-center">Uploading...</div>
                ) : (
                  <FileUpload
                    file={file}
                    setFile={setFile}
                    inputId="bills"
                    allowMultiple={false}
                  />
                )}
              </div>
              <div className="flex mt-5 gap-x-5">
                <div className="w-full overflow-x-scroll">
                  {/* <XlsxTableRefund file={file} reloadSheet={reloadSheet}/> */}
                  {!periodId ? <h4 className="text-center mt-4">Please Select a Period</h4> : (!sheetSummaryData ? <h4 className="text-center mt-4">No Summary Uploaded For the period !</h4> : <ViewSheetSummary sheetSummaryData={sheetSummaryData} handleSheetSubmit={sheetSubmitAction} handleSheetSubmitManager={handleSheetSubmitManager} sheetType="refunds" getSheet={getSheet} periodId={periodId} hadleDeleteSheet={hadleDeleteSheet} approverLevels={approverLevels} currentAction={currentAction} handleSkipSubmit={handleSkipSubmit} />)}
                </div>
                <div className="min-w-[16rem] bg-[#fafafa] mt-[19px] rounded-md p-3">
                  <div className="file-loading file-loading-comment">
                    <h4
                      className="jl-heading mt-0 card-title bold-font mb-3"
                      id="Filechange"
                    >
                      Upload Summary
                    </h4>
                    <div className="mb-1">Upload Refunds workings and summary (PDF or Excel files)</div>
                    {uploading ? (
                      <div className="text-center">Uploading...</div>
                    ) : (
                      <FileUpload
                        file={summaryFile}
                        setFile={handleSummaryFileChange}
                        inputId="summary"
                        allowMultiple={true}
                      />
                    )}
                  </div>
                  <div className="mb-3 mt-5">
                    <span
                      onClick={() => { setRightTab(0); getSheet(); }}
                      className={`${rightTab === 0 ? "bg-[#F37920] text-white" : ""
                        } text-xs cursor-pointer p-2 px-3 rounded-full relative`}
                    >
                      Download
                      {rightTab === 0 && (
                        <div className=" absolute w-0 h-0 left-10 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                      )}
                    </span>
                    <span
                      onClick={() => { setRightTab(1); getSheet(); }}
                      className={`${rightTab === 1 ? "bg-[#F37920] text-white" : ""
                        } text-xs cursor-pointer p-2 px-3 rounded-full relative`}
                    >
                      Comments{" "}
                      {rightTab === 1 && (
                        <div className=" absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                      )}
                    </span>
                  </div>

                  {rightTab === 0 ? (
                    <ul className="list-group list-group-flush r-list-group r-list-group-icon">
                      {summaryData?.map(summary => {
                        // Get the icon class using the utility function
                        const fileIconClass = getFileIconClass(summary.file_name);

                        return (
                          <li key={summary.id} className="list-group-item bg-white">
                            <a href={summary.url} target="_blank" rel="noreferrer">
                              <i className={`${fileIconClass} mx-2`}></i>{summary.file_name}
                            </a>
                            <small className="text-[#212529]">{moment(summary.updated_date).format('DD-MM-YYYY hh:mm:ss A')}</small>
                            <div className="mt-2 d-flex align-items-center gap-2">
                              {summary.preface_approval === 1 && (
                                <Badge bg="primary">Approved</Badge>
                              )}
                              {summary.preface_approval === 2 && (
                                <Badge bg="light">Rejected</Badge>
                              )}
                              {!manageAllClientsPermission && summary.preface_approval === 0 && (
                                <Badge bg="warning">Waiting</Badge>
                              )}
                              {manageAllClientsPermission && summary.preface_approval === 0 && (
                                <>
                                  <Button
                                    variant="primary"
                                    size="sm"
                                    className="py-0 px-1 !text-[12px]"
                                    onClick={() => handleSummaryApprove(summary.id, 1)}
                                  >
                                    Approve
                                  </Button>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="py-0 px-1 !text-[12px]"
                                    onClick={() => handleSummaryApprove(summary.id, 2)}
                                  >
                                    Reject
                                  </Button>
                                </>
                              )}
                            </div>
                          </li>
                        );
                      })
                      }
                    </ul>
                  ) : (
                    <div className="flex flex-col overflow-y-scroll h-[13rem]  mt-5 divide-y">
                      {allComments.map((comment) => (
                        <p
                          className={`hover:bg-[#f1f1f1] text-xs flex flex-col m-0 items-start gap-x-2 py-3 px-2 rounded-md cursor-pointer ${comment.status !== 4 ? "justify-between" : ""
                            }`}
                        >
                          <div className="flex w-full items-center gap-x-2">
                            {comment.status === 4 ? (
                              <FaCircleUser size={18} color="#fcbba5 " />
                            ) : (
                              <GoCommentDiscussion size={18} color="#fcbba5 " />
                            )}
                            <span>{comment.comment}</span>
                            {comment.status && (
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                  <Tooltip id={`button-tooltip-${comment.id}`}>
                                    {comment.status === 1 && "Approved"}
                                    {comment.status === 2 && "Rejected"}
                                    {comment.status === 4 && "Resolved"}
                                  </Tooltip>
                                }
                                container={document.body}
                              >
                                <span
                                  id={`button-tooltip-${comment.id}`}
                                  className="ml-auto"
                                >
                                  <FaCircleDot
                                    className={`${comment.status === 1 && "text-success"
                                      } ${comment.status === 4 && "text-success"} ${comment.status === 2 && "text-danger"
                                      } `}
                                  />
                                </span>
                              </OverlayTrigger>
                            )}
                          </div>
                          {/* Second line: Profile name */}
                          <div className="mt-1 text-gray-600">
                            <span className="text-xs">Added by: {comment.created_user_profile?.name || comment.created_user_profile?.email}</span>
                          </div>
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {activeTab === 1 && (
            <div>
              <div className="flex gap-x-3 -mb-8">
                {tabs.map((tab, i) => (
                  <p
                    key={i}
                    className={`${activeSubTab === i ? "bg-[#333333] text-white" : ""
                      } flex items-center gap-x-2 rounded-ss-md rounded-se-md px-2 py-1 cursor-pointer hover:bg-[#333333] hover:text-white`}
                    onClick={() => setActiveSubTab(i)}
                  >
                    {tab}
                    {activeSubTab === i && (
                      <span className="bg-green-500 text-white h-fit rounded-full p-px">
                        <FaCheck />
                      </span>
                    )}
                  </p>
                ))}
              </div>
              <hr className="border-blue-500 mb-5" />
              <div className="bg-[#fafafa] p-4 rounded-lg">
                <h1 className="text-xl mb-3 flex items-center gap-x-2">
                  {" "}
                  <img
                    className="w-10"
                    src="../assets/icons/up-loading.png"
                    alt="Upload Icon"
                  />{" "}
                  Download Shipping Bill
                </h1>
                <Collapse
                  accordion
                  items={billsData}
                  expandIcon={customExpandIcon}
                  expandIconPosition={"end"}
                />
              </div>
            </div>
          )}
          {activeTab === 2 && (
            <div>
              <RefundForm
                submitFunc={handleRefundSubmit}
                existingRefundItem={existingRefundItem}
                refundStatusOptions={refundStatusOptions}
              />
              {loading ? (
                <p className="text-center my-4">...loading</p>
              ) : (
                <RefundList
                  refundData={refundData}
                  refundEditAction={refundEditAction}
                  handleRefundDelete={triggerDelete}
                />
              )}
            </div>
          )}
        </>}
      </div>
      <ChatPopup client_id={client_id} chat_type="REFUND" />
      <ImportDrawer onImport={handleImportResponse} folder_id={periodId} gstrFormName="refund" />
      {importedData && (
        <FolderListModal
          show={folderListModalOpen}
          onHide={() => { setFolderListModalOpen(false); expand(); }}
          client_id={client_id}
          folder_id={periodId}
          data={importedData}
          gstrFormName="refund"
          year={null}
          month={null}
          subCategories={section_type}
          onSubmitSuccess={res => console.log('Submitted:', res)}
        />
      )}
      <DynamicModal
        show={confirmModal.show}
        onHide={() => setConfirmModal({ ...confirmModal, show: false })}
        title="Confirm Delete"
        buttons={[
          {
            label: 'Cancel',
            variant: 'secondary',
            action: 'custom',
            onClick: () => setConfirmModal({ ...confirmModal, show: false })
          },
          {
            label: 'Delete',
            variant: 'danger',
            action: 'custom',
            onClick: async () => {
              setConfirmModal({ ...confirmModal, show: false });
              if (confirmModal.onConfirm) await confirmModal.onConfirm();
            }
          }
        ]}
      >
        <p>{confirmModal.message}</p>
      </DynamicModal>
    </Base>
  );
};

export default Refunds;
